import { CUSOMER_SUPPORT_CONTACT_DETAILS } from "../../RequestToCallback/utils/constants";

const ExpertSupport = () => {
  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-border-b tw-border-t tw-border-solid tw-border-[#DADADA66] tw-py-8 tw-font-jakarta">
      <span className="tw-text-base tw-font-semibold">Need Help? </span>
      <span className="tw-text-base tw-font-medium">Call our expert support team at {CUSOMER_SUPPORT_CONTACT_DETAILS}</span>
    </div>
  );
};

export default ExpertSupport;
